/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResourceRightDto } from '../../models/resource-right-dto';

export interface GetResourceRights$Params {
  roleCode: string;
}

export function getResourceRights(http: HttpClient, rootUrl: string, params: GetResourceRights$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResourceRightDto>>> {
  const rb = new RequestBuilder(rootUrl, getResourceRights.PATH, 'get');
  if (params) {
    rb.path('roleCode', params.roleCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResourceRightDto>>;
    })
  );
}

getResourceRights.PATH = '/case-resources/rights/{roleCode}';
